import { QueryClient } from "@tanstack/react-query";

export const createAppQueryClient = queryDefaults =>
  new QueryClient({
    defaultOptions: {
      queries: queryDefaults,
    },
  });

export const creatorQueryClient = createAppQueryClient({
  refetchOnWindowFocus: false,
  refetchOnMount: true,
  refetchOnReconnect: false,
  retry: false,
  staleTime: Infinity,
});

export const manageBadgesQueryClient = createAppQueryClient({
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: Infinity,
});
